import { render } from "./Navbar.vue?vue&type=template&id=0848e43f&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=0848e43f&scoped=true&lang=css"
import "./Navbar.vue?vue&type=style&index=1&id=0848e43f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0848e43f"]])

export default __exports__